// @ts-nocheck
import { usePayrollRepository, usePayPeriodRepository } from '../repositories';
// TODO: useApprovePayrollRun needs a dedicated mutation not covered by repository CRUD.
// Once the repository supports custom mutations, remove this compat import.
import { useCompatMutation } from './useApolloCompat';
import { APPROVE_PAYROLL_MUTATION, PAYROLL_RUNS_QUERY, PAY_PERIODS_QUERY } from '../graphql/operations';

export function usePayrollRuns(variables?: { page?: number; perPage?: number; status?: string }) {
  const repo = usePayrollRepository();
  return repo.useList(variables);
}

export function usePayrollRun(id: string) {
  const repo = usePayrollRepository();
  return repo.useGet(id);
}

export function useRunPayroll() {
  const repo = usePayrollRepository();
  const { create, loading, error } = repo.useCreate();
  return {
    mutate: (input: any) => create(input),
    mutateAsync: (input: any) => create(input),
    isPending: loading,
    loading,
    error,
  };
}

// TODO: Migrate to repository pattern once custom mutations are supported.
// approvePayrollRun is a specialized action, not a standard CRUD update.
export function useApprovePayrollRun() {
  return useCompatMutation(APPROVE_PAYROLL_MUTATION, {
    refetchQueries: [{ query: PAYROLL_RUNS_QUERY }],
  });
}

export function usePayPeriods(variables?: { page?: number; perPage?: number }) {
  const repo = usePayPeriodRepository();
  return repo.useList(variables);
}
